import { Stack } from '@mui/material';
import styled from 'styled-components';

import { TFormContentProps } from '@/shared/components/ui/form/form.types';

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  min-height: 0;
`;

export const FormContainer = styled(Stack)`
  && {
    gap: 1.5rem;
    width: 100%;
    height: 100%;
    min-height: 0;

    > button {
      align-self: flex-end;
    }
  }
`;

export const FormContent = styled(Stack)<TFormContentProps>`
  && {
    height: 100%;
    min-height: 0;
    gap: 1rem;
    overflow: ${({ $overflowVisible }) =>
      $overflowVisible ? 'visible' : 'auto'};
  }
`;
